var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManualBill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 644"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M26.9193 16.2917V6.51667C26.9193 5.72326 26.9193 5.32656 26.7649 5.02351C26.629 4.75695 26.4123 4.54023 26.1458 4.40441C25.8427 4.25 25.446 4.25 24.6526 4.25H9.35261C8.5592 4.25 8.16249 4.25 7.85945 4.40441C7.59289 4.54023 7.37617 4.75695 7.24034 5.02351C7.08594 5.32656 7.08594 5.72326 7.08594 6.51667V27.4833C7.08594 28.2767 7.08594 28.6734 7.24034 28.9765C7.37617 29.243 7.59289 29.4598 7.85945 29.5956C8.16249 29.75 8.5592 29.75 9.3526 29.75H15.5859",
    stroke: "#20242E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_2",
    d: "M17.0026 22.666H11.3359",
    stroke: "#20242E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_3",
    d: "M21.2526 17H11.3359",
    stroke: "#20242E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_4",
    d: "M18.4193 11.334H11.3359",
    stroke: "#20242E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 161",
    cx: 22.6667,
    cy: 11.3327,
    r: 1.41667,
    fill: "#20242E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1528",
    d: "M24.8153 21.0742C25.1935 20.3893 26.0553 20.1405 26.7402 20.5187L27.9805 21.2033C28.6654 21.5815 28.9141 22.4433 28.536 23.1282L25.0811 29.3865L21.7826 30.7274L21.3604 27.3325L24.8153 21.0742Z",
    stroke: "#0E5CF4",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualBill);
export default __webpack_public_path__ + "static/media/manual-bill.5f18ecd4a4807eaf2aed13af543c7fba.svg";
export { ForwardRef as ReactComponent };